module.exports = __webpack_public_path__ + "img/Mom-icons_PaidSocial.249e9a9f.png";